/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SendPoolContributionRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {SendPoolContributionResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const sendPoolContribution = (request:SendPoolContributionRequest, options?: CashRequestOptions) => post<SendPoolContributionRequest, SendPoolContributionResponse>("/2.0/cash/send-pool-contribution", request, {...options, rejectOnError: true })